module.exports = __webpack_public_path__ + "assets/4d9e1ddeeb55e310ffb889ae66a43c87.png";